<template>
<div>
  <h2>Hva slags brukerdata behandler vi?</h2>
  <p>Vi lagrer annotering på boksidene av funksjonelle formål, og vi lagrer informasjonskapsler (cookies) for å analysere brukeradferd og trafikk på nettsiden. </p>
  <p><strong>Ved å bruke Tavleboka samtykker du til at vi kan sette informasjonskapsler (cookies) i din nettleser.</strong></p>
  <h2>Funksjonelle / Tekniske formål</h2>
  <p>Når du benytter Tavlebokas funksjonalitet for å annotere boksidene med tegninger, lenker, notater og favorittmerking av boksidene lagres dette med en unik bruker-id. Dette gjøres slik at annoteringen vises neste gang du benytter Tavleboka. Vi knytter ikke denne bruker-iden til deg som enkeltperson. </p>
  <h2>Analytiske formål</h2>
  <h3>Google Analytics</h3>
  <p>Vi bruker Google Analytics for å analysere brukeradferd og trafikk på nettsiden. Formålet er å forbedre funksjonalitet, brukervennlighet og innhold. Eksempler på statistikk er hvor mange som besøker siden, hvor lenge besøket varer, hvor brukerne kommer fra, hvilke nettlesere som benyttes. Ingen av informasjonskapslene gjør at vi kan knytte informasjon om din bruk av nettsiden til deg som enkeltperson.
  Om du ikke ønsker at Google Analytics skal samle dine besøksdata, kan du installere <a href="https://tools.google.com/dlpage/gaoptout" target="_blank">Google Analytics opt-out</a>.</p>
  <table>
    <thead>
      <tr>
        <th>Cookie</th>
        <th>Leverandør</th>
        <th>Hensikt</th>
        <th>Utløpsdato</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>_ga</td><td>Google</td><td>Brukes til å skille mellom brukere. ID kan ikke spores til bruker.</td><td>2 år</td>
      </tr>
      <tr>
        <td>_gid</td><td>Google</td><td>Brukes til å skille mellom brukere. ID kan ikke spores til bruker.</td><td>1 dag</td>
      </tr>
      <tr>
        <td>_gat</td><td>Google</td><td>Brukes til å begrense antall forespørsler mot nettstedet.</td><td>1 minutt</td>
      </tr>
    </tbody>
  </table>
  <p>Se for øvrig Cappelen Damm Undervisnings <a href="https://www.cappelendammundervisning.no/cdu/personvern/" target="_blank">retningslinjer for personvern</a>.</p>
</div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
h1 {
  margin: 0;
}
h2 {
  font-size: 1.1em;
  margin-bottom: 8px;
}
h3 {
  font-size: 1em;
  margin-bottom: 8px;
}
p {
  margin-bottom: 20px;
  font-size: 0.9em;
  line-height: 1.4em;
  &:last-child {
    margin-bottom: 0;
  }
}
table {
  border-collapse: collapse;
  font-size: 0.8em;
  margin-bottom: 10px;
  width: 100%;
  thead {
    text-align: left;
  }
  th, td {
    padding: 5px;
    border-bottom: 1px solid #ddd;
  }
}
</style>
